import { createActions, handleActions, Action } from "redux-actions";

interface Modelo {
  label: string;
  value: string;
}

/** Item crudo de la respuesta de versiones del backend. */
interface VersionResponse {
  codia: string;
  version: string;
}

interface GetModelosResponse {
  items: VersionResponse[];
}

interface FetchVehiculoModelosCompletedPayload {
  modelos: Modelo[];
}

interface VehiculoModelosState {
  isLoading: boolean;
  modelos: Modelo[];
}

// Tipado según la forma real en runtime: `~api/catalogos` declara `Promise<Modelo[]>`
// para este endpoint, pero lo que llega es el sobre `{ items }` que se mapea abajo.
interface Services {
  api: {
    vehiculos: () => {
      getModelos: (
        marca: string,
        anio: string
      ) => Promise<GetModelosResponse | null>;
    };
  };
}

const fetchVehiculoModelos = (marca: string, anio: string) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(fetchVehiculoModelosInited());

      const response = await services.api.vehiculos().getModelos(marca, anio);

      dispatch(fetchVehiculoModelosCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(fetchVehiculoModelosFailed(error));
    }
  };
};

const {
  vehiculoModelosReducer: {
    clear,
    fetchVehiculoModelosInited,
    fetchVehiculoModelosCompleted,
    fetchVehiculoModelosFailed,
  },
} = createActions({
  vehiculoModelosReducer: {
    clear: () => ({}),
    setMarca: (value: Modelo) => ({ value }),
    setModelo: (value: Modelo) => ({ value }),
    //
    fetchVehiculoModelosInited: () => ({}),
    fetchVehiculoModelosCompleted: (
      response: GetModelosResponse | null | undefined
    ): FetchVehiculoModelosCompletedPayload => {
      let modelos: Modelo[] = [];

      if (response?.items != null) {
        modelos = response.items.map((x) => ({
          value: x.codia,
          label: x.version,
        }));
      }

      return { modelos };
    },
    fetchVehiculoModelosFailed: (error: unknown) => ({ error }),
  },
});

const initialState: VehiculoModelosState = { isLoading: false, modelos: [] };

export const vehiculoModelosReducer = handleActions<VehiculoModelosState, any>(
  {
    [clear.toString()]: (): VehiculoModelosState => {
      return { ...initialState };
    },
    [fetchVehiculoModelosInited.toString()]: (
      state: VehiculoModelosState
    ): VehiculoModelosState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [fetchVehiculoModelosCompleted.toString()]: (
      state: VehiculoModelosState,
      action: Action<FetchVehiculoModelosCompletedPayload>
    ): VehiculoModelosState => {
      return {
        ...state,
        modelos: [...action.payload.modelos],
        isLoading: false,
      };
    },
    [fetchVehiculoModelosFailed.toString()]: (
      state: VehiculoModelosState
    ): VehiculoModelosState => {
      return {
        ...state,
        isLoading: false,
      };
    },
  },
  initialState
);

export default vehiculoModelosReducer;
export { clear, fetchVehiculoModelos };
